import { HStack, Text } from '@chakra-ui/react'
import { PEER_STALE_MS } from '../../constants/moderation'
import { useTranslation } from '../../i18n'

// Who else is working this queue, and how much each of them is holding.
//
// This is the load balancing made visible. Without it, a moderator has no way
// to tell "the queue is empty" from "the queue is full and someone else has it
// all", and no way to notice that a colleague's browser has gone quiet.

function initials(name, uid) {
  const source = (name || '').trim()
  if (!source) return (uid || '?').slice(0, 2).toUpperCase()
  const parts = source.split(/\s+/)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export function PresenceChips({ moderators, serverNow }) {
  const { t } = useTranslation()
  if (!moderators.length) return null

  return (
    <HStack gap={1} flexShrink={0}>
      {moderators.map((m) => {
        const age = m.lastHeartbeatMs ? serverNow() - m.lastHeartbeatMs : 0
        // Fading in the last third of the staleness window turns "about to be
        // declared gone" into something you can see coming.
        const fading = age > PEER_STALE_MS * 0.66
        return (
          <HStack
            key={m.sessionId}
            gap={1}
            px={1.5}
            py={0.5}
            borderRadius="full"
            bg={m.isMe ? 'var(--mc-bg-selected)' : 'var(--mc-fill-soft)'}
            border="1px solid"
            borderColor={m.isMe ? 'var(--mc-border-strong)' : 'transparent'}
            opacity={fading ? 0.45 : 1}
            transition="opacity 0.3s"
            title={`${m.displayName || m.uid || ''}${m.isMe ? ` (${t('moderation.you')})` : ''} — ${t('moderation.holdingCount', { count: m.load })}`}
          >
            <Text
              fontSize="0.6rem"
              fontFamily="'JetBrains Mono', monospace"
              color={m.isMe ? 'var(--mc-text)' : 'var(--mc-steel)'}
            >
              {initials(m.displayName, m.uid)}
            </Text>
            <Text fontSize="0.6rem" fontFamily="'JetBrains Mono', monospace" color="var(--mc-text)">
              {m.load}
            </Text>
          </HStack>
        )
      })}
    </HStack>
  )
}
